var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1514 15.5C14.6382 15.5 15.7348 14.4034 15.7348 12.9167C15.7348 11.43 14.6382 10.3333 13.1514 10.3333C11.6647 10.3333 10.5681 11.43 10.5681 12.9167C10.5681 14.4034 11.6634 15.5 13.1514 15.5Z",
    fill: "#3A3839",
    fillOpacity: 0.69
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.436 5.16666H5.76937C4.34466 5.16666 3.18604 6.25296 3.18604 7.58854V23.4115C3.18604 24.747 4.34466 25.8333 5.76937 25.8333H26.436C27.8607 25.8333 29.0194 24.747 29.0194 23.4115V7.58854C29.0194 6.25296 27.8607 5.16666 26.436 5.16666ZM26.436 23.25L5.76937 23.2358V7.75L26.436 7.76421V23.25Z",
    fill: "#3A3839",
    fillOpacity: 0.69
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6861 11.625H23.8528V14.2083H18.6861V11.625ZM19.9778 16.7917H23.8528V19.375H19.9778V16.7917ZM17.9499 20.0673C17.9499 18.2926 15.785 16.4688 13.1513 16.4688C10.5176 16.4688 8.35278 18.2926 8.35278 20.0673V20.6667H17.9499V20.0673Z",
    fill: "#3A3839",
    fillOpacity: 0.69
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cf26b79d7a419982d218523a26b2f042.svg";
export { ForwardRef as ReactComponent };